import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/core/services';
import { AccountSettingsVerticalTabParam } from 'src/app/modals/account-settings/constants';
import { VerticalMenuTabsEnum } from 'src/app/modals/account-settings/enum';
import { ModalNavigationEnum } from 'src/app/shared/constants';
import { AccountAttributesEnum } from 'src/app/shared/enums';

@UntilDestroy()
@Component({
    selector: 'app-integration-card',
    templateUrl: './integration-card.component.html',
    styleUrls: ['./integration-card.component.scss', '../../common-reporting-dashboard.scss'],
    standalone: false
})
export class IntegrationCardComponent implements OnInit {

    isAdmin$: Observable<boolean>;

    integrationLogos = [
        { name: 'HubSpot', src: '../../../../../assets/integration-logos/HubSpot-Logo.png', modal: ModalNavigationEnum.HUBSPOT },
        { name: 'Marketo', src: '../../../../../assets/integration-logos/MARKETO_LOGO.jpg', modal: ModalNavigationEnum.MARKETO },
        { name: 'Dynamics 365', src: '../../../../../assets/integration-logos/Dynamics-365-logo.png', modal: ModalNavigationEnum.DYNAMICS },
        { name: 'Outreach', src: '../../../../../assets/integration-logos/outreach_logo.png', modal: ModalNavigationEnum.OUTREACH },
        { name: 'Salesforce', src: '../../../../../assets/integration-logos/Salesforce.com_logo.svg', modal: ModalNavigationEnum.SALESFORCE },
        { name: 'Salesloft', src: '../../../../../assets/integration-logos/salesloft-logo-full-color-rgb.png', modal: ModalNavigationEnum.SALESLOFT },
        { name: 'Zoho', src: '../../../../../assets/integration-logos/Zoho-logo.png', modal: ModalNavigationEnum.ZOHO },
    ];
    

    readonly modalNavigationEnum: typeof ModalNavigationEnum = ModalNavigationEnum;
    readonly accountAttributes: typeof AccountAttributesEnum = AccountAttributesEnum;

    constructor(private readonly router: Router,
        private readonly userService: UserService
    ) { }

    ngOnInit(): void {
        this.isAdmin$ = this.userService.listenToUserChangesByKey('is_admin');
    }

    onOpenSettings(modal: ModalNavigationEnum): void {
        this.router.navigate(['/', { outlets: { modal: [modal] } }], {
            queryParamsHandling: 'merge'
        })
    }

    onOpenCustomSettings(modal: ModalNavigationEnum): void {
        this.isAdmin$.pipe(
            untilDestroyed(this)
        ).subscribe((isAdmin) => {
            if(isAdmin && this.userService.hasAccess(AccountAttributesEnum.APPS)) {
                this.router.navigate(['/', { outlets: { modal: [modal] } }], {
                    queryParams: {
                        [AccountSettingsVerticalTabParam]: VerticalMenuTabsEnum.CREATE_APPS,
                    },
                    queryParamsHandling: 'merge'
                })
            }
        })
    }
    
}
